import script from "./CompactAudioplayer.vue?vue&type=script&setup=true&lang=js"
export * from "./CompactAudioplayer.vue?vue&type=script&setup=true&lang=js"

import "./CompactAudioplayer.vue?vue&type=style&index=0&id=634f9b26&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634f9b26"]])

export default __exports__